import { useMemo, useState } from "react";
import { useCurrentLocation } from "../../context/LocationContext";
import { useLatest } from "../../hooks";
import * as api from "../../services/api";

export function useServiceData(service_id) {
  const [options, setOptions] = useState();
  const res = useMemo(
    () => ({ service: options ?? null, loading: options == null }),
    [options],
  );

  useLatest(
    async (signal) => {
      setOptions(null);
      const result = await api.loadServicesWithTemplates(
        {
          filter: {
            id: { eq: service_id },
          },
        },
        { signal },
      );
      setOptions(result.data.services.data[0]);
    },
    [service_id],
  );

  return res;
}

export function useServiceOptions(client_id) {
  const location = useCurrentLocation();

  const [options, setOptions] = useState();
  const res = useMemo(
    () => ({ options: options ?? [], loading: options == null }),
    [options],
  );

  useLatest(
    async (signal) => {
      setOptions(null);
      const result = await api.loadServicesWithTemplates(
        {
          filter: {
            visible: { eq: true },
            create_reservation: { eq: true },
            product: {
              client_id: { eq: client_id },
              company_id: { eq: location.company_id },
            },
          },
        },
        { signal },
      );
      setOptions(result.data.services.data);
    },
    [client_id, location],
  );

  return res;
}
